declare global {
  interface Window {
    Wix: any;
  }
}

const {
  Wix,
  Wix: {
    Events: wixEvents = null,
    // WindowOrigin = 'FIXED',
    // WindowPlacement = 'BOTTOM_CENTER',
  } = {},
} = window;

export { Wix, wixEvents };

export const getInstance = (): string => {
  const instance =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('instance')
      : '';
  return instance || '';
};

export const getCompId = (): string => {
  return Wix ? Wix.Utils.getCompId() : getOrigCompId();
};

export const getOrigCompId = (): string => {
  return Wix ? Wix.Utils.getOrigCompId() : '';
};

export const getSiteInfo = (callback?: (data: any) => void): any => {
  return Wix.getSiteInfo(callback);
};

export const getStyleParams = (callback?: (event: any) => void): any => {
  return Wix.Styles.getStyleParams(callback);
};

export const applicationLoadingStep = (steps: number): void => {
  Wix && Wix.Performance.applicationLoadingStep(steps);
};

export const listenStyleParamsCahnge = (
  callback: (event: any) => void,
): void => {
  Wix && Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, callback);
};

export const setTimezoneNumberParam = (value): void => {
  Wix && Wix.Styles.setNumberParam('timeZone', { value });
};

export const setStartWeekOnNumberParam = (value: number): void => {
  Wix && Wix.Styles.setNumberParam('startWeekOn', { value });
};

export const setHeight = (height: number): void => {
  Wix && Wix.setHeight(height);
};

export const resizeComponent = ({ width, height }: { width: number; height: number }) => {
  Wix.Styles.getStyleParams((styleParams) => {
    const isStudio = styleParams?.booleans?.responsive;

    if (isEditorViewMode() && !isStudio) {
      console.log('resizeComponent', width, height);
      Wix.Settings.resizeComponent({
        width,
        height,
      });
    }
  });
};

export const triggerSettingsUpdatedEvent = (data: {
  key: string;
  value: any;
}): void => {
  Wix && Wix.Settings.triggerSettingsUpdatedEvent(data);
};

export const getDeviceType = (): string => {
  const deviceType = Wix && Wix.Utils.getDeviceType()
  return  deviceType || 'desktop';
};

export const getLocale = (): string => {
  // WIX_LOCALES_TYPE
  return Wix ? Wix.Utils.getLocale() : 'en';
};

export const getWidth = (): number => {
  const width = Wix && Wix.Utils.getWidth();
  return width;
};

export const isMobileDevice = (): boolean => {
  return getDeviceType() === 'mobile';
};

export const getViewMode = (): string => {
  return Wix ? Wix.Utils.getViewMode() : 'editor';
};

export const getSiteColors = (): any[] => {
  return Wix ? Wix.Styles.getSiteColors() : [];
};

export const isEditorViewMode = (): boolean => {
  return getViewMode() === 'editor';
};

export const isLiveSiteViewMode = (): boolean => {
  return getViewMode() === 'site';
};

export const getWixPublicData = (key: string, scope: string) => {
  return new Promise((resolve, reject) => {
    Wix &&
      Wix.Data.Public.get(
        key,
        {
          scope,
        },
        (d: any) => {
          console.log('success on get data public', scope, d);
          resolve(d);
        },
        (f: any) => {
          reject(f);
        },
      );
  });
};

export const getInstanceId = (): string => {
  const url = new URL(window.location.href);
  const instanceId = url.searchParams.get('instanceId');
  return instanceId ? instanceId : Wix ? Wix.Utils.getInstanceId() : '';
};

export const getMetaSiteId = (): string => {
  return Wix ? Wix.Utils.getInstanceValue('metaSiteId') : '';
};

export const getUUId = (): string => {
  return Wix ? Wix.Utils.getInstanceValue('uid') : '';
};

export const getBiToken = (): string => {
  const DEFAULT_BI_TOKEN = '44444444-cccc-5555-dddd-666666666666';
  return Wix && Wix.Utils.getInstanceValue('biToken')
    ? Wix.Utils.getInstanceValue('biToken')
    : DEFAULT_BI_TOKEN;
};

export const getVisitorId = (): string => {
  return Wix ? Wix.Utils.getInstanceValue('aid') : '';
};

export const applicationLoaded = (): void => {
  Wix && Wix.Performance.applicationLoaded();
};

const position = {
  origin: Wix.WindowOrigin.FIXED,
  placement: Wix.WindowPlacement.BOTTOM_CENTER,
  x: 0,
  y: 0,
};

export const openWixPopup = (
  url: string,
  width: string,
  height: string,
  onClose: Function,
): void => {
  Wix && Wix.openPopup(url, width, height, position, onClose, Wix.Theme.BARE);
};
